export function encodeProperties(properties: Record<string, any>): string | null {
  try {
    return Buffer.from(JSON.stringify(properties)).toString('base64');
  } catch (e) {
    return null;
  }
}
